import React from 'react';

import { accountType$ } from '../../../../emitters/account';
import withState from '../../../../utils/withState';
import Caption from '../../../dumb/Caption/C';

import PayoutsHistory from './PayoutsHistory';
import Balance from './Balance';

module.exports = withState(() => {
  return () => {
    return (
      <div>
        {/*<Caption*/}
        {/*  data-testid="titleDashboard"*/}
        {/*>*/}
        {/*  Dashboard*/}
        {/*</Caption>*/}
        <Balance />
        <div className="mt36">
          <PayoutsHistory />
        </div>
      </div>
    )
  };
}, {
  accountType: accountType$,
});
